export const enum ECodigoParametro {
    'Investimento' = 1,
    'ContaResultadoEFechamentoDeMina' = 2,
}